export default __webpack_public_path__ + "images/pl-7ea4b5b2df865bf73b06a50c1763b50e.svg";